import React from "react";
import "./wizard-preview.scss";

export interface PreviewRowItem {
  label: string;
  value: React.ReactNode;
  /** Renders the value with bolder emphasis. */
  emphasis?: boolean;
}

/** A single label/value pair. Empty values render a muted em-dash. */
export const PreviewRow: React.FC<PreviewRowItem> = ({
  label,
  value,
  emphasis = false,
}) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "");
  return (
    <div className="tlx-preview-kv__row">
      <dt className="tlx-preview-kv__label">{label}</dt>
      <dd
        className={`tlx-preview-kv__value${
          emphasis ? " tlx-preview-kv__value--emphasis" : ""
        }`}
      >
        {isEmpty ? (
          <span className="tlx-preview-kv__placeholder" aria-hidden>
            —
          </span>
        ) : (
          value
        )}
      </dd>
    </div>
  );
};

export interface PreviewKeyValueListProps {
  items: PreviewRowItem[];
}

/** A definition-list of label/value rows. */
export const PreviewKeyValueList: React.FC<PreviewKeyValueListProps> = ({
  items,
}) => (
  <dl className="tlx-preview-kv">
    {/* Index-qualified: labels can come from user data (a custom attribute's
        variable name, say), so they are not unique enough to key on alone. */}
    {items.map((item, index) => (
      <PreviewRow key={`${item.label}-${index}`} {...item} />
    ))}
  </dl>
);

export default PreviewKeyValueList;
